// extracted by mini-css-extract-plugin
export default {"Skill":"Skill_Skill__aRGT0","IconImage":"Skill_IconImage__QS7ep","SkillText":"Skill_SkillText__vP6xL"};